import useSwr from "swr";
import api from "./api";

export function useFetchRegistration<Data = any, Error = any>() {
  const url = `/registration`;

  const { data, error } = useSwr<Data, Error>(url, async (url) => {
    const response = await api.get(url);
    return response.data;
  });

  return { data, error };
}
